import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import { AccordionRoot } from "~/components/ui/Accordions/Accordion/Accordion";
import type { AccordionStoryblok } from "~/generated/sb/blok-types";
import styles from "./AccordionBlok.module.css";

const alignments = {
	left: styles.left,
	center: styles.center,
	right: styles.right,
	full: styles.full,
};

export const AccordionBlok = ({ blok, preview }: BlokProps<AccordionStoryblok>) => {
	return (
		<BlokWrap data-layout="blok" editable={blok}>
			<div className={clsx(styles.accordionRoot, blok.align && alignments[blok.align])}>
				{blok.title && <h3 className={styles.title}>{blok.title}</h3>}
				<AccordionRoot>
					{blok.items.map((item, i) => (
						<StoryblokComponent preview={preview} blok={item} key={blok._uid} index={i} />
					))}
				</AccordionRoot>
			</div>
		</BlokWrap>
	);
};
